import { render, staticRenderFns } from "./AccordionContentInput2.vue?vue&type=template&id=795ba387&scoped=true"
import script from "./AccordionContentInput2.vue?vue&type=script&lang=js"
export * from "./AccordionContentInput2.vue?vue&type=script&lang=js"
import style0 from "./AccordionContentInput2.vue?vue&type=style&index=0&id=795ba387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ba387",
  null
  
)

export default component.exports